// Types
import { VictoryAreas, VictoryPointScatters, VictoryLines } from './Components';
import { RatingRanges } from '@globalTypes/index';

export const victoryLines: VictoryLines = [
  {
    data: [
      {
        x: 0,
        y: 0.2,
      },
      {
        x: 0.20202020202020202,
        y: 0.3,
      },
      {
        x: 0.40404040404040403,
        y: 0.5,
      },
    ],
    title: 'Ballast after drydock',
    styleKey: 'lightDashed',
    id: 'ballastAfterDrydock',
  },
];

export const resistanceLines: VictoryLines = [
  {
    data: [
      {
        x: '2021-09-27T00:00:00.000Z',
        y: 2.5435616438356163,
      },
      {
        x: '2021-09-29T00:00:00.000Z',
        y: 2.5542448510484905,
      },
    ],
    styleKey: 'black',
    id: 'resistance',
  },
];

export const victoryAreas: VictoryAreas = [
  {
    key: 'A',
    rate: 'A',
    data: [
      {
        x: '2023-08-01T00:00:00.000Z',
        y0: 7.951013637003423,
        y: 7.953332770544747,
      },
      {
        x: '2023-08-02T00:00:00.000Z',
        y0: 7.951311996134032,
        y: 7.941492841507733,
      },
      {
        x: '2023-08-03T00:00:00.000Z',
        y0: 7.95161035526464,
        y: 7.92965291247072,
      },
      {
        x: '2023-08-04T00:00:00.000Z',
        y0: 7.951908714395249,
        y: 7.917812983433707,
      },
      {
        x: '2023-08-05T00:00:00.000Z',
        y0: 7.952207073525858,
        y: 7.905973054396695,
      },
      {
        x: '2023-08-06T00:00:00.000Z',
        y0: 7.952505432656467,
        y: 7.894133125359682,
      },
      {
        x: '2023-08-07T00:00:00.000Z',
        y0: 7.952803791787075,
        y: 7.882293196322669,
      },
      {
        x: '2023-08-08T00:00:00.000Z',
        y0: 7.953102150917684,
        y: 7.870453267285656,
      },
      {
        x: '2023-08-09T00:00:00.000Z',
        y0: 7.953400510048293,
        y: 7.858613338248641,
      },
      {
        x: '2023-08-10T00:00:00.000Z',
        y0: 7.95296506802024,
        y: 7.851518956958863,
      },
      {
        x: '2023-08-11T00:00:00.000Z',
        y0: 7.952529625992187,
        y: 7.844424575669086,
      },
      {
        x: '2023-08-12T00:00:00.000Z',
        y0: 7.952094183964134,
        y: 7.837330194379309,
      },
      {
        x: '2023-08-13T00:00:00.000Z',
        y0: 7.951658741936082,
        y: 7.830235813089532,
      },
      {
        x: '2023-08-14T00:00:00.000Z',
        y0: 7.951223299908029,
        y: 7.823141431799755,
      },
      {
        x: '2023-08-15T00:00:00.000Z',
        y0: 7.950787857879976,
        y: 7.816047050509978,
      },
      {
        x: '2023-08-16T00:00:00.000Z',
        y0: 7.950352415851923,
        y: 7.808952669220201,
      },
      {
        x: '2023-08-17T00:00:00.000Z',
        y0: 7.949916973823871,
        y: 7.801858287930421,
      },
      {
        x: '2023-08-18T00:00:00.000Z',
        y0: 7.955170326788988,
        y: 7.789329761026633,
      },
      {
        x: '2023-08-19T00:00:00.000Z',
        y0: 7.960423679754104,
        y: 7.776801234122845,
      },
      {
        x: '2023-08-20T00:00:00.000Z',
        y0: 7.965677032719221,
        y: 7.764272707219058,
      },
      {
        x: '2023-08-21T00:00:00.000Z',
        y0: 7.970930385684337,
        y: 7.75174418031527,
      },
      {
        x: '2023-08-22T00:00:00.000Z',
        y0: 7.976183738649453,
        y: 7.739215653411482,
      },
      {
        x: '2023-08-23T00:00:00.000Z',
        y0: 7.98143709161457,
        y: 7.726687126507694,
      },
      {
        x: '2023-08-24T00:00:00.000Z',
        y0: 7.986690444579686,
        y: 7.714158599603906,
      },
      {
        x: '2023-08-25T00:00:00.000Z',
        y0: 7.9919437975448036,
        y: 7.701630072700118,
      },
      {
        x: '2023-08-26T00:00:00.000Z',
        y0: 7.994007221254782,
        y: 7.690183489971851,
      },
      {
        x: '2023-08-27T00:00:00.000Z',
        y0: 7.996070644964761,
        y: 7.678736907243584,
      },
      {
        x: '2023-08-28T00:00:00.000Z',
        y0: 7.99813406867474,
        y: 7.667290324515317,
      },
      {
        x: '2023-08-29T00:00:00.000Z',
        y0: 8.000197492384718,
        y: 7.65584374178705,
      },
      {
        x: '2023-08-30T00:00:00.000Z',
        y0: 8.002260916094697,
        y: 7.644397159058784,
      },
      {
        x: '2023-08-31T00:00:00.000Z',
        y0: 8.004324339804676,
        y: 7.632950576330517,
      },
      {
        x: '2023-09-01T00:00:00.000Z',
        y0: 8.006387763514654,
        y: 7.62150399360225,
      },
      {
        x: '2023-09-02T00:00:00.000Z',
        y0: 8.008451187224633,
        y: 7.61005741087398,
      },
      {
        x: '2023-09-03T00:00:00.000Z',
        y0: 8.003259835677046,
        y: 7.597249596114337,
      },
      {
        x: '2023-09-04T00:00:00.000Z',
        y0: 7.998068484129458,
        y: 7.584441781354695,
      },
      {
        x: '2023-09-05T00:00:00.000Z',
        y0: 7.992877132581871,
        y: 7.571633966595052,
      },
      {
        x: '2023-09-06T00:00:00.000Z',
        y0: 7.987685781034283,
        y: 7.55882615183541,
      },
      {
        x: '2023-09-07T00:00:00.000Z',
        y0: 7.982494429486696,
        y: 7.546018337075767,
      },
      {
        x: '2023-09-08T00:00:00.000Z',
        y0: 7.9773030779391085,
        y: 7.533210522316125,
      },
      {
        x: '2023-09-09T00:00:00.000Z',
        y0: 7.972111726391521,
        y: 7.5204027075564825,
      },
      {
        x: '2023-09-10T00:00:00.000Z',
        y0: 7.966920374843933,
        y: 7.5075948927968374,
      },
      {
        x: '2023-09-11T00:00:00.000Z',
        y0: 7.97100631086189,
        y: 7.500700378054059,
      },
      {
        x: '2023-09-12T00:00:00.000Z',
        y0: 7.975092246879847,
        y: 7.493805863311282,
      },
      {
        x: '2023-09-13T00:00:00.000Z',
        y0: 7.979178182897805,
        y: 7.486911348568505,
      },
      {
        x: '2023-09-14T00:00:00.000Z',
        y0: 7.983264118915762,
        y: 7.480016833825728,
      },
      {
        x: '2023-09-15T00:00:00.000Z',
        y0: 7.987350054933719,
        y: 7.47312231908295,
      },
      {
        x: '2023-09-16T00:00:00.000Z',
        y0: 7.991435990951676,
        y: 7.466227804340173,
      },
      {
        x: '2023-09-17T00:00:00.000Z',
        y0: 7.995521926969634,
        y: 7.459333289597396,
      },
      {
        x: '2023-09-18T00:00:00.000Z',
        y0: 7.999607862987592,
        y: 7.452438774854616,
      },
      {
        x: '2023-09-19T00:00:00.000Z',
        y0: 7.998848871150297,
        y: 7.450624053208125,
      },
      {
        x: '2023-09-20T00:00:00.000Z',
        y0: 7.998089879313003,
        y: 7.448809331561634,
      },
      {
        x: '2023-09-21T00:00:00.000Z',
        y0: 7.997330887475709,
        y: 7.4469946099151425,
      },
      {
        x: '2023-09-22T00:00:00.000Z',
        y0: 7.996571895638414,
        y: 7.445179888268651,
      },
      {
        x: '2023-09-23T00:00:00.000Z',
        y0: 7.99581290380112,
        y: 7.44336516662216,
      },
      {
        x: '2023-09-24T00:00:00.000Z',
        y0: 7.995053911963826,
        y: 7.441550444975668,
      },
      {
        x: '2023-09-25T00:00:00.000Z',
        y0: 7.994294920126531,
        y: 7.439735723329177,
      },
      {
        x: '2023-09-26T00:00:00.000Z',
        y0: 7.993535928289239,
        y: 7.437921001682688,
      },
      {
        x: '2023-09-27T00:00:00.000Z',
        y0: 8.001160954776907,
        y: 7.43016845854847,
      },
      {
        x: '2023-09-28T00:00:00.000Z',
        y0: 8.008785981264575,
        y: 7.422415915414253,
      },
      {
        x: '2023-09-29T00:00:00.000Z',
        y0: 8.016411007752243,
        y: 7.414663372280035,
      },
      {
        x: '2023-09-30T00:00:00.000Z',
        y0: 8.024036034239911,
        y: 7.406910829145818,
      },
      {
        x: '2023-10-01T00:00:00.000Z',
        y0: 8.03166106072758,
        y: 7.3991582860116,
      },
      {
        x: '2023-10-02T00:00:00.000Z',
        y0: 8.039286087215247,
        y: 7.3914057428773825,
      },
      {
        x: '2023-10-03T00:00:00.000Z',
        y0: 8.046911113702915,
        y: 7.383653199743165,
      },
      {
        x: '2023-10-04T00:00:00.000Z',
        y0: 8.054536140190583,
        y: 7.375900656608946,
      },
      {
        x: '2023-10-05T00:00:00.000Z',
        y0: 8.050301594403802,
        y: 7.368385237308678,
      },
      {
        x: '2023-10-06T00:00:00.000Z',
        y0: 8.04606704861702,
        y: 7.36086981800841,
      },
      {
        x: '2023-10-07T00:00:00.000Z',
        y0: 8.041832502830239,
        y: 7.353354398708142,
      },
      {
        x: '2023-10-08T00:00:00.000Z',
        y0: 8.037597957043458,
        y: 7.345838979407874,
      },
      {
        x: '2023-10-09T00:00:00.000Z',
        y0: 8.033363411256676,
        y: 7.338323560107606,
      },
      {
        x: '2023-10-10T00:00:00.000Z',
        y0: 8.029128865469895,
        y: 7.330808140807338,
      },
      {
        x: '2023-10-11T00:00:00.000Z',
        y0: 8.024894319683114,
        y: 7.32329272150707,
      },
      {
        x: '2023-10-12T00:00:00.000Z',
        y0: 8.02065977389633,
        y: 7.3157773022068,
      },
      {
        x: '2023-10-13T00:00:00.000Z',
        y0: 8.026071216984587,
        y: 7.308496917579793,
      },
      {
        x: '2023-10-14T00:00:00.000Z',
        y0: 8.031482660072843,
        y: 7.301216532952788,
      },
      {
        x: '2023-10-15T00:00:00.000Z',
        y0: 8.0368941031611,
        y: 7.293936148325782,
      },
      {
        x: '2023-10-16T00:00:00.000Z',
        y0: 8.042305546249356,
        y: 7.286655763698777,
      },
      {
        x: '2023-10-17T00:00:00.000Z',
        y0: 8.047716989337612,
        y: 7.279375379071771,
      },
      {
        x: '2023-10-18T00:00:00.000Z',
        y0: 8.053128432425869,
        y: 7.272094994444766,
      },
      {
        x: '2023-10-19T00:00:00.000Z',
        y0: 8.058539875514125,
        y: 7.26481460981776,
      },
      {
        x: '2023-10-20T00:00:00.000Z',
        y0: 8.063951318602376,
        y: 7.257534225190752,
      },
      {
        x: '2023-10-21T00:00:00.000Z',
        y0: 8.064655182911904,
        y: 7.2510667609915,
      },
      {
        x: '2023-10-22T00:00:00.000Z',
        y0: 8.065359047221433,
        y: 7.244599296792248,
      },
      {
        x: '2023-10-23T00:00:00.000Z',
        y0: 8.066062911530961,
        y: 7.2381318325929955,
      },
      {
        x: '2023-10-24T00:00:00.000Z',
        y0: 8.06676677584049,
        y: 7.231664368393743,
      },
      {
        x: '2023-10-25T00:00:00.000Z',
        y0: 8.067470640150018,
        y: 7.225196904194491,
      },
      {
        x: '2023-10-26T00:00:00.000Z',
        y0: 8.068174504459547,
        y: 7.218729439995239,
      },
      {
        x: '2023-10-27T00:00:00.000Z',
        y0: 8.068878368769075,
        y: 7.212261975795987,
      },
      {
        x: '2023-10-28T00:00:00.000Z',
        y0: 8.069582233078604,
        y: 7.205794511596732,
      },
      {
        x: '2023-10-29T00:00:00.000Z',
        y0: 8.070080421056396,
        y: 7.197822542245407,
      },
      {
        x: '2023-10-30T00:00:00.000Z',
        y0: 8.070578609034188,
        y: 7.189850572894082,
      },
      {
        x: '2023-10-31T00:00:00.000Z',
        y0: 8.07107679701198,
        y: 7.181878603542757,
      },
      {
        x: '2023-11-01T00:00:00.000Z',
        y0: 8.071574984989772,
        y: 7.173906634191432,
      },
      {
        x: '2023-11-02T00:00:00.000Z',
        y0: 8.072073172967563,
        y: 7.165934664840107,
      },
      {
        x: '2023-11-03T00:00:00.000Z',
        y0: 8.072571360945355,
        y: 7.1579626954887825,
      },
      {
        x: '2023-11-04T00:00:00.000Z',
        y0: 8.073069548923147,
        y: 7.149990726137458,
      },
      {
        x: '2023-11-05T00:00:00.000Z',
        y0: 8.07356773690094,
        y: 7.142018756786132,
      },
      {
        x: '2023-11-06T00:00:00.000Z',
        y0: 8.07422968680525,
        y: 7.13774573055466,
      },
      {
        x: '2023-11-07T00:00:00.000Z',
        y0: 8.074891636709559,
        y: 7.1334727043231885,
      },
      {
        x: '2023-11-08T00:00:00.000Z',
        y0: 8.075553586613868,
        y: 7.129199678091717,
      },
      {
        x: '2023-11-09T00:00:00.000Z',
        y0: 8.076215536518177,
        y: 7.124926651860245,
      },
      {
        x: '2023-11-10T00:00:00.000Z',
        y0: 8.076877486422486,
        y: 7.120653625628774,
      },
      {
        x: '2023-11-11T00:00:00.000Z',
        y0: 8.077539436326795,
        y: 7.116380599397302,
      },
      {
        x: '2023-11-12T00:00:00.000Z',
        y0: 8.078201386231104,
        y: 7.11210757316583,
      },
      {
        x: '2023-11-13T00:00:00.000Z',
        y0: 8.07886333613541,
        y: 7.107834546934356,
      },
      {
        x: '2023-11-14T00:00:00.000Z',
        y0: 8.076422399616584,
        y: 7.113263821832722,
      },
      {
        x: '2023-11-15T00:00:00.000Z',
        y0: 8.073981463097759,
        y: 7.1186930967310875,
      },
      {
        x: '2023-11-16T00:00:00.000Z',
        y0: 8.071540526578934,
        y: 7.124122371629453,
      },
      {
        x: '2023-11-17T00:00:00.000Z',
        y0: 8.069099590060109,
        y: 7.129551646527819,
      },
      {
        x: '2023-11-18T00:00:00.000Z',
        y0: 8.066658653541284,
        y: 7.134980921426185,
      },
      {
        x: '2023-11-19T00:00:00.000Z',
        y0: 8.064217717022458,
        y: 7.1404101963245505,
      },
      {
        x: '2023-11-20T00:00:00.000Z',
        y0: 8.061776780503633,
        y: 7.145839471222916,
      },
      {
        x: '2023-11-21T00:00:00.000Z',
        y0: 8.059335843984806,
        y: 7.151268746121282,
      },
      {
        x: '2023-11-22T00:00:00.000Z',
        y0: 8.058783006733824,
        y: 7.148992201079138,
      },
      {
        x: '2023-11-23T00:00:00.000Z',
        y0: 8.058230169482842,
        y: 7.146715656036994,
      },
      {
        x: '2023-11-24T00:00:00.000Z',
        y0: 8.05767733223186,
        y: 7.14443911099485,
      },
      {
        x: '2023-11-25T00:00:00.000Z',
        y0: 8.057124494980878,
        y: 7.142162565952706,
      },
      {
        x: '2023-11-26T00:00:00.000Z',
        y0: 8.056571657729895,
        y: 7.139886020910562,
      },
      {
        x: '2023-11-27T00:00:00.000Z',
        y0: 8.056018820478913,
        y: 7.137609475868418,
      },
      {
        x: '2023-11-28T00:00:00.000Z',
        y0: 8.055465983227931,
        y: 7.135332930826274,
      },
      {
        x: '2023-11-29T00:00:00.000Z',
        y0: 8.05491314597695,
        y: 7.133056385784127,
      },
      {
        x: '2023-11-30T00:00:00.000Z',
        y0: 8.053321041836684,
        y: 7.11963366422626,
      },
      {
        x: '2023-12-01T00:00:00.000Z',
        y0: 8.051728937696417,
        y: 7.106210942668394,
      },
      {
        x: '2023-12-02T00:00:00.000Z',
        y0: 8.05013683355615,
        y: 7.092788221110528,
      },
      {
        x: '2023-12-03T00:00:00.000Z',
        y0: 8.048544729415884,
        y: 7.079365499552662,
      },
      {
        x: '2023-12-04T00:00:00.000Z',
        y0: 8.046952625275617,
        y: 7.065942777994795,
      },
      {
        x: '2023-12-05T00:00:00.000Z',
        y0: 8.04536052113535,
        y: 7.052520056436929,
      },
      {
        x: '2023-12-06T00:00:00.000Z',
        y0: 8.043768416995084,
        y: 7.039097334879063,
      },
      {
        x: '2023-12-07T00:00:00.000Z',
        y0: 8.042176312854815,
        y: 7.025674613321194,
      },
      {
        x: '2023-12-08T00:00:00.000Z',
        y0: 8.04744553698352,
        y: 7.029803102919473,
      },
      {
        x: '2023-12-09T00:00:00.000Z',
        y0: 8.052714761112226,
        y: 7.033931592517751,
      },
      {
        x: '2023-12-10T00:00:00.000Z',
        y0: 8.05798398524093,
        y: 7.038060082116029,
      },
      {
        x: '2023-12-11T00:00:00.000Z',
        y0: 8.063253209369636,
        y: 7.042188571714307,
      },
      {
        x: '2023-12-12T00:00:00.000Z',
        y0: 8.068522433498341,
        y: 7.046317061312585,
      },
      {
        x: '2023-12-13T00:00:00.000Z',
        y0: 8.073791657627046,
        y: 7.0504455509108634,
      },
      {
        x: '2023-12-14T00:00:00.000Z',
        y0: 8.079060881755751,
        y: 7.0545740405091415,
      },
      {
        x: '2023-12-15T00:00:00.000Z',
        y0: 8.084330105884451,
        y: 7.058702530107422,
      },
      {
        x: '2023-12-16T00:00:00.000Z',
        y0: 8.084817503656726,
        y: 7.0575330069948095,
      },
      {
        x: '2023-12-17T00:00:00.000Z',
        y0: 8.085304901429001,
        y: 7.056363483882197,
      },
      {
        x: '2023-12-18T00:00:00.000Z',
        y0: 8.085792299201277,
        y: 7.055193960769584,
      },
      {
        x: '2023-12-19T00:00:00.000Z',
        y0: 8.086279696973552,
        y: 7.054024437656971,
      },
      {
        x: '2023-12-20T00:00:00.000Z',
        y0: 8.086767094745827,
        y: 7.052854914544358,
      },
      {
        x: '2023-12-21T00:00:00.000Z',
        y0: 8.087254492518102,
        y: 7.051685391431746,
      },
      {
        x: '2023-12-22T00:00:00.000Z',
        y0: 8.087741890290378,
        y: 7.050515868319133,
      },
      {
        x: '2023-12-23T00:00:00.000Z',
        y0: 8.088229288062657,
        y: 7.0493463452065175,
      },
      {
        x: '2023-12-24T00:00:00.000Z',
        y0: 8.089552625006837,
        y: 7.0469670795120525,
      },
      {
        x: '2023-12-25T00:00:00.000Z',
        y0: 8.090875961951017,
        y: 7.0445878138175875,
      },
      {
        x: '2023-12-26T00:00:00.000Z',
        y0: 8.092199298895197,
        y: 7.0422085481231225,
      },
      {
        x: '2023-12-27T00:00:00.000Z',
        y0: 8.093522635839378,
        y: 7.0398292824286575,
      },
      {
        x: '2023-12-28T00:00:00.000Z',
        y0: 8.094845972783558,
        y: 7.0374500167341925,
      },
      {
        x: '2023-12-29T00:00:00.000Z',
        y0: 8.096169309727738,
        y: 7.0350707510397275,
      },
      {
        x: '2023-12-30T00:00:00.000Z',
        y0: 8.097492646671919,
        y: 7.0326914853452624,
      },
      {
        x: '2023-12-31T00:00:00.000Z',
        y0: 8.098815983616097,
        y: 7.0303122196507974,
      },
    ],
    styleKey: 'A',
  },
  { key: 'B', rate: 'B', data: [], styleKey: 'B' },
  { key: 'C', rate: 'C', data: [], styleKey: 'C' },
  { key: 'D', rate: 'D', data: [], styleKey: 'D' },
  { key: 'E', rate: 'E', data: [], styleKey: 'E' },
];

export const victoryLinesArea: VictoryLines = [
  {
    data: [
      {
        y: 7.133322784681734,
        x: '2023-01-01 08:00:00',
      },
      {
        y: 7.164204966103326,
        x: '2023-01-02 09:00:00',
      },
      {
        y: 7.107081607583385,
        x: '2023-01-03 09:00:00',
      },
      {
        y: 7.2498137805575205,
        x: '2023-01-04 09:00:00',
      },
      {
        y: 7.248491594043555,
        x: '2023-01-05 10:00:00',
      },
      {
        y: 7.289972901680781,
        x: '2023-01-05 21:30:00',
      },
      {
        y: 7.529418170323656,
        x: '2023-01-06 10:00:00',
      },
      {
        y: 8.015563606364559,
        x: '2023-01-07 10:00:00',
      },
      {
        y: 8.524136330350734,
        x: '2023-01-08 10:00:00',
      },
      {
        y: 9.085039392875885,
        x: '2023-01-09 10:00:00',
      },
      {
        y: 9.616039404807339,
        x: '2023-01-10 10:00:00',
      },
      {
        y: 10.034902977012415,
        x: '2023-01-11 06:00:00',
      },
      {
        y: 10.034963357051513,
        x: '2023-01-11 10:00:00',
      },
      {
        y: 10.092061637528792,
        x: '2023-01-12 10:00:00',
      },
      {
        y: 9.969350405988935,
        x: '2023-01-12 20:30:00',
      },
      {
        y: 10.234293467094606,
        x: '2023-01-13 10:00:00',
      },
      {
        y: 10.611027981420014,
        x: '2023-01-14 10:00:00',
      },
      {
        y: 10.881680973425693,
        x: '2023-01-15 00:00:00',
      },
      {
        y: 10.854441234595873,
        x: '2023-01-15 10:00:00',
      },
      {
        y: 10.735762759957227,
        x: '2023-01-16 02:00:00',
      },
      {
        y: 10.817965590286507,
        x: '2023-01-16 10:00:00',
      },
      {
        y: 11.156578803704758,
        x: '2023-01-17 10:00:00',
      },
      {
        y: 11.248886541616788,
        x: '2023-01-17 20:00:00',
      },
      {
        y: 11.219717964303886,
        x: '2023-01-17 20:01:00',
      },
      {
        y: 11.39494040110871,
        x: '2023-01-18 10:00:00',
      },
      {
        y: 11.316448690870105,
        x: '2023-01-19 10:00:00',
      },
      {
        y: 11.289119882992054,
        x: '2023-01-20 10:00:00',
      },
      {
        y: 11.75859229786961,
        x: '2023-01-21 10:00:00',
      },
      {
        y: 11.97172847673076,
        x: '2023-01-22 10:00:00',
      },
      {
        y: 11.863125969380874,
        x: '2023-01-23 10:00:00',
      },
      {
        y: 11.968602504355813,
        x: '2023-01-23 21:00:00',
      },
      {
        y: 12.055491687897515,
        x: '2023-01-24 10:00:00',
      },
      {
        y: 12.197339441829332,
        x: '2023-01-25 10:00:00',
      },
      {
        y: 12.30645309869996,
        x: '2023-01-26 01:30:00',
      },
      {
        y: 12.19944852797738,
        x: '2023-01-26 09:00:00',
      },
      {
        y: 12.213689535036092,
        x: '2023-01-26 10:00:00',
      },
      {
        y: 12.363220109152586,
        x: '2023-01-27 10:00:00',
      },
      {
        y: 12.434425144446154,
        x: '2023-01-27 19:00:00',
      },
      {
        y: 12.048262407776237,
        x: '2023-01-28 10:00:00',
      },
      {
        y: 11.73300773145557,
        x: '2023-01-29 10:00:00',
      },
      {
        y: 11.390804620888032,
        x: '2023-01-30 10:00:00',
      },
      {
        y: 11.017035409594616,
        x: '2023-01-31 11:00:00',
      },
      {
        y: 10.734744502529741,
        x: '2023-02-01 11:00:00',
      },
      {
        y: 10.47176725527241,
        x: '2023-02-02 12:00:00',
      },
      {
        y: 10.235397742836001,
        x: '2023-02-03 12:00:00',
      },
      {
        y: 10.023913810158533,
        x: '2023-02-04 12:00:00',
      },
      { y: 9.8040028978235, x: '2023-02-05 13:00:00' },
      {
        y: 9.625208924965596,
        x: '2023-02-06 13:00:00',
      },
      { y: 9.45383451771261, x: '2023-02-07 13:00:00' },
      {
        y: 9.300024026769337,
        x: '2023-02-08 13:00:00',
      },
      {
        y: 9.161259232280402,
        x: '2023-02-09 14:00:00',
      },
      {
        y: 9.067474221347974,
        x: '2023-02-10 14:00:00',
      },
      {
        y: 8.985436367125986,
        x: '2023-02-11 14:00:00',
      },
      {
        y: 8.892776275048655,
        x: '2023-02-12 15:00:00',
      },
      {
        y: 8.802138822446164,
        x: '2023-02-13 15:00:00',
      },
      {
        y: 8.730590535600037,
        x: '2023-02-14 15:00:00',
      },
      {
        y: 8.637236680043351,
        x: '2023-02-15 16:00:00',
      },
      {
        y: 8.569018466425064,
        x: '2023-02-16 16:00:00',
      },
      {
        y: 8.508203867010565,
        x: '2023-02-17 16:00:00',
      },
      {
        y: 8.437844889132823,
        x: '2023-02-18 16:00:00',
      },
      {
        y: 8.410622943567507,
        x: '2023-02-19 17:00:00',
      },
      {
        y: 8.407320251393864,
        x: '2023-02-20 17:00:00',
      },
      { y: 8.39687985809741, x: '2023-02-21 08:00:00' },
      {
        y: 8.422216134587769,
        x: '2023-02-21 17:00:00',
      },
      {
        y: 8.453886480200719,
        x: '2023-02-22 17:00:00',
      },
      {
        y: 8.531162123496316,
        x: '2023-02-23 17:00:00',
      },
      {
        y: 8.541296634092461,
        x: '2023-02-23 18:00:00',
      },
      {
        y: 8.480631049906648,
        x: '2023-02-24 17:00:00',
      },
      {
        y: 8.446413728352207,
        x: '2023-02-25 09:42:00',
      },
      {
        y: 8.481635733656695,
        x: '2023-02-25 17:00:00',
      },
      {
        y: 8.518072290868236,
        x: '2023-02-26 07:30:00',
      },
      { y: 8.4892168217667, x: '2023-02-26 17:00:00' },
      {
        y: 8.469674855612578,
        x: '2023-02-27 17:00:00',
      },
      {
        y: 8.452452808788571,
        x: '2023-02-28 17:00:00',
      },
      { y: 8.39225415638331, x: '2023-03-01 18:00:00' },
      {
        y: 8.357742822678174,
        x: '2023-03-02 18:00:00',
      },
      {
        y: 8.343124827438478,
        x: '2023-03-03 00:06:00',
      },
      {
        y: 8.378468292621433,
        x: '2023-03-03 18:00:00',
      },
      {
        y: 8.432587973682834,
        x: '2023-03-04 18:00:00',
      },
      {
        y: 8.478976271735464,
        x: '2023-03-05 18:00:00',
      },
      {
        y: 8.511006287057516,
        x: '2023-03-06 18:00:00',
      },
      { y: 8.55960355168408, x: '2023-03-07 18:00:00' },
      {
        y: 8.620350132467282,
        x: '2023-03-08 18:00:00',
      },
      {
        y: 8.635812898484826,
        x: '2023-03-08 20:00:00',
      },
      {
        y: 8.608760073270501,
        x: '2023-03-09 18:00:00',
      },
      { y: 8.60679470410885, x: '2023-03-09 19:00:00' },
      {
        y: 8.726545217982784,
        x: '2023-03-10 18:00:00',
      },
      { y: 8.79774822623215, x: '2023-03-11 18:00:00' },
      {
        y: 8.825797896148565,
        x: '2023-03-12 17:00:00',
      },
      { y: 8.85600523298163, x: '2023-03-13 17:00:00' },
      {
        y: 8.887291403273018,
        x: '2023-03-14 17:00:00',
      },
      {
        y: 8.922892907397701,
        x: '2023-03-15 17:00:00',
      },
      {
        y: 8.990859415272096,
        x: '2023-03-16 17:00:00',
      },
      {
        y: 9.036170420521692,
        x: '2023-03-17 00:00:00',
      },
      {
        y: 9.035278409824514,
        x: '2023-03-17 17:00:00',
      },
      {
        y: 8.991985443171373,
        x: '2023-03-18 17:00:00',
      },
      {
        y: 8.938873882469327,
        x: '2023-03-19 17:00:00',
      },
      {
        y: 8.907070032486907,
        x: '2023-03-20 12:12:00',
      },
      {
        y: 8.921858741443442,
        x: '2023-03-20 17:00:00',
      },
      {
        y: 8.967210782243486,
        x: '2023-03-21 17:00:00',
      },
      { y: 9.01256282304353, x: '2023-03-22 17:00:00' },
      {
        y: 9.021436048417451,
        x: '2023-03-22 20:00:00',
      },
      {
        y: 8.989145017412806,
        x: '2023-03-23 17:00:00',
      },
      {
        y: 8.949813691644973,
        x: '2023-03-24 17:00:00',
      },
      {
        y: 8.942164607600452,
        x: '2023-03-25 17:00:00',
      },
      {
        y: 8.891892990662548,
        x: '2023-03-26 13:42:00',
      },
      {
        y: 8.898549214573436,
        x: '2023-03-26 17:00:00',
      },
      {
        y: 8.924223221086859,
        x: '2023-03-27 17:00:00',
      },
      {
        y: 8.958455229771426,
        x: '2023-03-28 17:00:00',
      },
      { y: 8.98698190367523, x: '2023-03-29 17:00:00' },
      {
        y: 9.019312134099541,
        x: '2023-03-30 17:00:00',
      },
      {
        y: 9.048789697133474,
        x: '2023-03-31 17:00:00',
      },
      { y: 9.06210214495525, x: '2023-04-01 03:30:00' },
      { y: 9.05508682584863, x: '2023-04-01 08:06:00' },
      {
        y: 9.067409076503365,
        x: '2023-04-01 17:00:00',
      },
      {
        y: 9.110063021077453,
        x: '2023-04-02 17:00:00',
      },
      {
        y: 9.133759656951943,
        x: '2023-04-03 17:00:00',
      },
      {
        y: 9.167882812611214,
        x: '2023-04-04 17:00:00',
      },
      {
        y: 9.189683717615745,
        x: '2023-04-05 17:00:00',
      },
      {
        y: 9.232337662189831,
        x: '2023-04-07 17:00:00',
      },
      {
        y: 9.256034298064323,
        x: '2023-04-07 21:00:00',
      },
      {
        y: 9.210995443562389,
        x: '2023-04-08 17:00:00',
      },
      { y: 9.15654186875668, x: '2023-04-09 17:00:00' },
      {
        y: 9.074800121367394,
        x: '2023-04-10 17:00:00',
      },
      {
        y: 9.049094332500143,
        x: '2023-04-11 17:00:00',
      },
      { y: 9.05295051620244, x: '2023-04-12 17:00:00' },
      {
        y: 9.025370181146268,
        x: '2023-04-13 16:00:00',
      },
      {
        y: 8.985115447783546,
        x: '2023-04-14 15:00:00',
      },
      {
        y: 8.939335410477463,
        x: '2023-04-15 15:00:00',
      },
      {
        y: 8.899144559371802,
        x: '2023-04-16 14:00:00',
      },
      {
        y: 8.867505425083596,
        x: '2023-04-17 13:00:00',
      },
      {
        y: 8.828204521119297,
        x: '2023-04-18 13:00:00',
      },
      {
        y: 8.793180496149459,
        x: '2023-04-19 12:00:00',
      },
      {
        y: 8.755731279322108,
        x: '2023-04-20 12:00:00',
      },
      { y: 8.71847124887343, x: '2023-04-21 11:00:00' },
      {
        y: 8.681297570920158,
        x: '2023-04-22 11:00:00',
      },
      { y: 8.64587063520435, x: '2023-04-23 10:00:00' },
      {
        y: 8.611215349914914,
        x: '2023-04-24 10:00:00',
      },
      {
        y: 8.569803155680301,
        x: '2023-04-25 10:00:00',
      },
      { y: 8.57010309081294, x: '2023-04-25 16:00:00' },
      { y: 8.59045989959916, x: '2023-04-26 04:12:00' },
      {
        y: 8.585614564090706,
        x: '2023-04-26 08:00:00',
      },
      {
        y: 8.590517092355576,
        x: '2023-04-26 10:00:00',
      },
      { y: 8.61432937249922, x: '2023-04-27 10:00:00' },
      {
        y: 8.636740930281478,
        x: '2023-04-28 07:30:00',
      },
      {
        y: 8.631384216618844,
        x: '2023-04-28 10:00:00',
      },
      {
        y: 8.596015107263725,
        x: '2023-04-29 10:00:00',
      },
      {
        y: 8.558161938307688,
        x: '2023-04-30 10:00:00',
      },
      { y: 8.51380654460083, x: '2023-05-01 10:00:00' },
      {
        y: 8.475398406147306,
        x: '2023-05-02 10:00:00',
      },
      { y: 8.47613132029927, x: '2023-05-02 13:30:00' },
      { y: 8.49848607420845, x: '2023-05-03 10:00:00' },
      { y: 8.52610077021391, x: '2023-05-04 10:00:00' },
      {
        y: 8.533333190596291,
        x: '2023-05-04 13:00:00',
      },
      {
        y: 8.505213526666036,
        x: '2023-05-05 10:00:00',
      },
      {
        y: 8.467490657909254,
        x: '2023-05-06 10:00:00',
      },
      {
        y: 8.441027663682297,
        x: '2023-05-07 09:00:00',
      },
      { y: 8.4412994454252, x: '2023-05-07 15:42:00' },
      {
        y: 8.458319680076924,
        x: '2023-05-08 09:00:00',
      },
      { y: 8.46021081726045, x: '2023-05-08 11:00:00' },
      { y: 8.44722178895392, x: '2023-05-08 19:00:00' },
      { y: 8.46733518549331, x: '2023-05-09 00:30:00' },
      {
        y: 8.466989688402883,
        x: '2023-05-09 09:00:00',
      },
      {
        y: 8.466484749143033,
        x: '2023-05-09 10:00:00',
      },
      {
        y: 8.491565653198458,
        x: '2023-05-10 09:00:00',
      },
      { y: 8.49281969840123, x: '2023-05-10 10:24:00' },
      {
        y: 8.490628459394078,
        x: '2023-05-10 13:00:00',
      },
      {
        y: 8.508172790672754,
        x: '2023-05-11 09:00:00',
      },
      {
        y: 8.525717121951429,
        x: '2023-05-12 02:00:00',
      },
      {
        y: 8.518020416390621,
        x: '2023-05-12 09:00:00',
      },
      {
        y: 8.516788734929724,
        x: '2023-05-12 12:00:00',
      },
      { y: 8.53012019654982, x: '2023-05-12 16:00:00' },
      {
        y: 8.513585788539492,
        x: '2023-05-13 09:00:00',
      },
      { y: 8.50310878295726, x: '2023-05-14 09:00:00' },
      {
        y: 8.500182679946455,
        x: '2023-05-14 21:06:00',
      },
      {
        y: 8.514760396442654,
        x: '2023-05-15 09:00:00',
      },
      {
        y: 8.518404825566703,
        x: '2023-05-15 11:30:00',
      },
      { y: 8.50152607698947, x: '2023-05-16 09:00:00' },
      {
        y: 8.457264374714965,
        x: '2023-05-17 10:00:00',
      },
      { y: 8.42333298154821, x: '2023-05-18 10:00:00' },
      {
        y: 8.383726668312137,
        x: '2023-05-19 10:00:00',
      },
      {
        y: 8.350743165937091,
        x: '2023-05-20 10:00:00',
      },
      {
        y: 8.316653598182723,
        x: '2023-05-21 10:00:00',
      },
      {
        y: 8.276318887401505,
        x: '2023-05-22 10:00:00',
      },
      {
        y: 8.277947867302851,
        x: '2023-05-22 22:06:00',
      },
      {
        y: 8.286870170672417,
        x: '2023-05-23 10:00:00',
      },
      {
        y: 8.300811269687362,
        x: '2023-05-24 10:00:00',
      },
      {
        y: 8.323117028111275,
        x: '2023-05-25 10:00:00',
      },
      {
        y: 8.346538074456381,
        x: '2023-05-26 10:00:00',
      },
      {
        y: 8.366613257037901,
        x: '2023-05-27 04:00:00',
      },
      {
        y: 8.361451053894724,
        x: '2023-05-27 10:00:00',
      },
      { y: 8.33716812604335, x: '2023-05-28 11:00:00' },
      {
        y: 8.315581897774134,
        x: '2023-05-29 12:00:00',
      },
      {
        y: 8.298018125347571,
        x: '2023-05-30 12:00:00',
      },
      { y: 8.27902145069976, x: '2023-05-31 13:00:00' },
      {
        y: 8.262180017120132,
        x: '2023-06-01 14:00:00',
      },
      {
        y: 8.247569416944355,
        x: '2023-06-02 14:00:00',
      },
      {
        y: 8.229314916008672,
        x: '2023-06-03 14:00:00',
      },
      {
        y: 8.214789557364398,
        x: '2023-06-04 15:00:00',
      },
      { y: 8.20074394889639, x: '2023-06-05 15:00:00' },
      { y: 8.18408206162756, x: '2023-06-06 16:00:00' },
      {
        y: 8.164320032413421,
        x: '2023-06-07 16:00:00',
      },
      { y: 8.14322923858034, x: '2023-06-08 17:00:00' },
      {
        y: 8.122902725546865,
        x: '2023-06-09 17:00:00',
      },
      {
        y: 8.123780440716006,
        x: '2023-06-10 12:00:00',
      },
      {
        y: 8.129543610187415,
        x: '2023-06-10 17:00:00',
      },
      {
        y: 8.143471269743321,
        x: '2023-06-11 17:00:00',
      },
      {
        y: 8.175168701836071,
        x: '2023-06-12 16:30:00',
      },
      {
        y: 8.174921749560054,
        x: '2023-06-12 17:00:00',
      },
      {
        y: 8.158302885042627,
        x: '2023-06-13 17:00:00',
      },
      {
        y: 8.144618092626127,
        x: '2023-06-14 17:00:00',
      },
      {
        y: 8.137041881998687,
        x: '2023-06-15 16:00:00',
      },
      {
        y: 8.129323451315903,
        x: '2023-06-16 16:00:00',
      },
      { y: 8.11357494461205, x: '2023-06-17 16:00:00' },
      {
        y: 8.100038640525328,
        x: '2023-06-18 16:00:00',
      },
      {
        y: 8.085742709569592,
        x: '2023-06-19 16:00:00',
      },
      {
        y: 8.082307878362029,
        x: '2023-06-19 21:48:00',
      },
      {
        y: 8.100155248947141,
        x: '2023-06-20 16:00:00',
      },
      {
        y: 8.118437921253843,
        x: '2023-06-21 16:00:00',
      },
      {
        y: 8.131496972901484,
        x: '2023-06-22 06:00:00',
      },
      {
        y: 8.122764869218253,
        x: '2023-06-22 16:00:00',
      },
      {
        y: 8.108046548461164,
        x: '2023-06-23 17:00:00',
      },
      { y: 8.09268814065066, x: '2023-06-24 17:00:00' },
      {
        y: 8.065380993977753,
        x: '2023-06-25 16:30:00',
      },
      {
        y: 8.067067065286631,
        x: '2023-06-25 17:00:00',
      },
      { y: 8.08687840316594, x: '2023-06-26 17:00:00' },
      {
        y: 8.104160634081932,
        x: '2023-06-27 16:30:00',
      },
      {
        y: 8.103704655789537,
        x: '2023-06-27 17:00:00',
      },
      { y: 8.08396490172717, x: '2023-06-28 11:00:00' },
      {
        y: 8.088984143079156,
        x: '2023-06-28 17:00:00',
      },
      {
        y: 8.104878407360442,
        x: '2023-06-29 17:00:00',
      },
      {
        y: 8.106133217698439,
        x: '2023-06-29 17:30:00',
      },
      {
        y: 8.083086876232214,
        x: '2023-06-30 17:00:00',
      },
      {
        y: 8.059065273010173,
        x: '2023-07-01 17:00:00',
      },
      { y: 8.03825219272362, x: '2023-07-02 18:00:00' },
      {
        y: 8.018524584570084,
        x: '2023-07-03 12:00:00',
      },
      {
        y: 8.022553763151615,
        x: '2023-07-03 17:00:00',
      },
      { y: 8.03786464176144, x: '2023-07-04 18:00:00' },
      {
        y: 8.052369684654956,
        x: '2023-07-05 16:00:00',
      },
      {
        y: 8.050499928547072,
        x: '2023-07-05 18:00:00',
      },
      {
        y: 8.040907974864924,
        x: '2023-07-06 10:00:00',
      },
      {
        y: 8.044110704083897,
        x: '2023-07-06 18:00:00',
      },
      {
        y: 8.058522985569267,
        x: '2023-07-08 18:00:00',
      },
      {
        y: 8.064127761702467,
        x: '2023-07-09 05:00:00',
      },
      {
        y: 8.051375518152073,
        x: '2023-07-09 18:00:00',
      },
      {
        y: 8.033656381167233,
        x: '2023-07-10 17:00:00',
      },
      {
        y: 8.034038910345412,
        x: '2023-07-11 13:48:00',
      },
      {
        y: 8.037692127703895,
        x: '2023-07-11 17:00:00',
      },
      {
        y: 8.062046910093782,
        x: '2023-07-12 17:00:00',
      },
      { y: 8.06448238833277, x: '2023-07-12 17:30:00' },
      {
        y: 8.052334915399134,
        x: '2023-07-13 17:00:00',
      },
      {
        y: 8.051720026556406,
        x: '2023-07-14 16:00:00',
      },
      {
        y: 8.045667381308963,
        x: '2023-07-15 16:00:00',
      },
      {
        y: 8.035539009504813,
        x: '2023-07-16 15:00:00',
      },
      {
        y: 8.024299458968938,
        x: '2023-07-17 15:00:00',
      },
      {
        y: 8.015472413232757,
        x: '2023-07-18 15:00:00',
      },
      { y: 8.00329575605925, x: '2023-07-19 14:00:00' },
      {
        y: 7.990453333204696,
        x: '2023-07-20 14:00:00',
      },
      {
        y: 7.980313603526006,
        x: '2023-07-21 13:00:00',
      },
      {
        y: 7.971158566226576,
        x: '2023-07-22 13:00:00',
      },
      {
        y: 7.958723587778538,
        x: '2023-07-23 12:00:00',
      },
      { y: 7.94673979467854, x: '2023-07-24 12:00:00' },
      {
        y: 7.932861865221275,
        x: '2023-07-25 12:00:00',
      },
      {
        y: 7.920462822903613,
        x: '2023-07-26 11:00:00',
      },
      {
        y: 7.911925685556503,
        x: '2023-07-27 10:00:00',
      },
      {
        y: 7.900434580832501,
        x: '2023-07-28 10:00:00',
      },
      {
        y: 7.897278236195343,
        x: '2023-07-28 16:30:00',
      },
      {
        y: 7.909074397497806,
        x: '2023-07-29 10:00:00',
      },
      {
        y: 7.928019747468425,
        x: '2023-07-30 10:00:00',
      },
      {
        y: 7.943747962538374,
        x: '2023-07-31 10:00:00',
      },
    ],
    styleKey: 'light',
    id: 'historical',
    title: 'CII Current',
  },
  {
    data: [
      {
        x: '2023-08-01T00:00:00.000Z',
        y: 7.945144463938793,
      },
      {
        x: '2023-08-02T00:00:00.000Z',
        y: 7.936670090794234,
      },
      {
        x: '2023-08-03T00:00:00.000Z',
        y: 7.9281957176496745,
      },
      {
        x: '2023-08-04T00:00:00.000Z',
        y: 7.919721344505115,
      },
      {
        x: '2023-08-05T00:00:00.000Z',
        y: 7.911246971360556,
      },
      {
        x: '2023-08-06T00:00:00.000Z',
        y: 7.902772598215996,
      },
      {
        x: '2023-08-07T00:00:00.000Z',
        y: 7.894298225071437,
      },
      {
        x: '2023-08-08T00:00:00.000Z',
        y: 7.885823851926878,
      },
      {
        x: '2023-08-09T00:00:00.000Z',
        y: 7.8773494787823175,
      },
      {
        x: '2023-08-10T00:00:00.000Z',
        y: 7.879018111662431,
      },
      {
        x: '2023-08-11T00:00:00.000Z',
        y: 7.880686744542544,
      },
      {
        x: '2023-08-12T00:00:00.000Z',
        y: 7.882355377422657,
      },
      {
        x: '2023-08-13T00:00:00.000Z',
        y: 7.88402401030277,
      },
      {
        x: '2023-08-14T00:00:00.000Z',
        y: 7.8856926431828835,
      },
      {
        x: '2023-08-15T00:00:00.000Z',
        y: 7.887361276062997,
      },
      {
        x: '2023-08-16T00:00:00.000Z',
        y: 7.88902990894311,
      },
      {
        x: '2023-08-17T00:00:00.000Z',
        y: 7.890698541823222,
      },
      {
        x: '2023-08-18T00:00:00.000Z',
        y: 7.886425380855625,
      },
      {
        x: '2023-08-19T00:00:00.000Z',
        y: 7.882152219888028,
      },
      {
        x: '2023-08-20T00:00:00.000Z',
        y: 7.877879058920431,
      },
      {
        x: '2023-08-21T00:00:00.000Z',
        y: 7.873605897952834,
      },
      {
        x: '2023-08-22T00:00:00.000Z',
        y: 7.869332736985237,
      },
      {
        x: '2023-08-23T00:00:00.000Z',
        y: 7.86505957601764,
      },
      {
        x: '2023-08-24T00:00:00.000Z',
        y: 7.860786415050043,
      },
      {
        x: '2023-08-25T00:00:00.000Z',
        y: 7.8565132540824445,
      },
      {
        x: '2023-08-26T00:00:00.000Z',
        y: 7.851240965472051,
      },
      {
        x: '2023-08-27T00:00:00.000Z',
        y: 7.845968676861657,
      },
      {
        x: '2023-08-28T00:00:00.000Z',
        y: 7.8406963882512635,
      },
      {
        x: '2023-08-29T00:00:00.000Z',
        y: 7.8354240996408695,
      },
      {
        x: '2023-08-30T00:00:00.000Z',
        y: 7.8301518110304755,
      },
      {
        x: '2023-08-31T00:00:00.000Z',
        y: 7.824879522420082,
      },
      {
        x: '2023-09-01T00:00:00.000Z',
        y: 7.819607233809688,
      },
      {
        x: '2023-09-02T00:00:00.000Z',
        y: 7.814334945199296,
      },
      {
        x: '2023-09-03T00:00:00.000Z',
        y: 7.808741142572256,
      },
      {
        x: '2023-09-04T00:00:00.000Z',
        y: 7.803147339945215,
      },
      {
        x: '2023-09-05T00:00:00.000Z',
        y: 7.797553537318175,
      },
      {
        x: '2023-09-06T00:00:00.000Z',
        y: 7.791959734691134,
      },
      {
        x: '2023-09-07T00:00:00.000Z',
        y: 7.786365932064093,
      },
      {
        x: '2023-09-08T00:00:00.000Z',
        y: 7.780772129437053,
      },
      {
        x: '2023-09-09T00:00:00.000Z',
        y: 7.775178326810012,
      },
      {
        x: '2023-09-10T00:00:00.000Z',
        y: 7.769584524182974,
      },
      {
        x: '2023-09-11T00:00:00.000Z',
        y: 7.7648706656354465,
      },
      {
        x: '2023-09-12T00:00:00.000Z',
        y: 7.7601568070879186,
      },
      {
        x: '2023-09-13T00:00:00.000Z',
        y: 7.755442948540391,
      },
      {
        x: '2023-09-14T00:00:00.000Z',
        y: 7.750729089992863,
      },
      {
        x: '2023-09-15T00:00:00.000Z',
        y: 7.746015231445335,
      },
      {
        x: '2023-09-16T00:00:00.000Z',
        y: 7.741301372897807,
      },
      {
        x: '2023-09-17T00:00:00.000Z',
        y: 7.736587514350279,
      },
      {
        x: '2023-09-18T00:00:00.000Z',
        y: 7.731873655802753,
      },
      {
        x: '2023-09-19T00:00:00.000Z',
        y: 7.729355402073165,
      },
      {
        x: '2023-09-20T00:00:00.000Z',
        y: 7.726837148343577,
      },
      {
        x: '2023-09-21T00:00:00.000Z',
        y: 7.724318894613989,
      },
      {
        x: '2023-09-22T00:00:00.000Z',
        y: 7.7218006408844015,
      },
      {
        x: '2023-09-23T00:00:00.000Z',
        y: 7.719282387154814,
      },
      {
        x: '2023-09-24T00:00:00.000Z',
        y: 7.716764133425226,
      },
      {
        x: '2023-09-25T00:00:00.000Z',
        y: 7.714245879695638,
      },
      {
        x: '2023-09-26T00:00:00.000Z',
        y: 7.711727625966052,
      },
      {
        x: '2023-09-27T00:00:00.000Z',
        y: 7.708871389760195,
      },
      {
        x: '2023-09-28T00:00:00.000Z',
        y: 7.706015153554338,
      },
      {
        x: '2023-09-29T00:00:00.000Z',
        y: 7.703158917348481,
      },
      {
        x: '2023-09-30T00:00:00.000Z',
        y: 7.700302681142624,
      },
      {
        x: '2023-10-01T00:00:00.000Z',
        y: 7.697446444936767,
      },
      {
        x: '2023-10-02T00:00:00.000Z',
        y: 7.69459020873091,
      },
      {
        x: '2023-10-03T00:00:00.000Z',
        y: 7.691733972525053,
      },
      {
        x: '2023-10-04T00:00:00.000Z',
        y: 7.688877736319194,
      },
      {
        x: '2023-10-05T00:00:00.000Z',
        y: 7.684209371867771,
      },
      {
        x: '2023-10-06T00:00:00.000Z',
        y: 7.679541007416349,
      },
      {
        x: '2023-10-07T00:00:00.000Z',
        y: 7.674872642964926,
      },
      {
        x: '2023-10-08T00:00:00.000Z',
        y: 7.670204278513504,
      },
      {
        x: '2023-10-09T00:00:00.000Z',
        y: 7.665535914062081,
      },
      {
        x: '2023-10-10T00:00:00.000Z',
        y: 7.660867549610659,
      },
      {
        x: '2023-10-11T00:00:00.000Z',
        y: 7.656199185159236,
      },
      {
        x: '2023-10-12T00:00:00.000Z',
        y: 7.651530820707817,
      },
      {
        x: '2023-10-13T00:00:00.000Z',
        y: 7.650489986273429,
      },
      {
        x: '2023-10-14T00:00:00.000Z',
        y: 7.64944915183904,
      },
      {
        x: '2023-10-15T00:00:00.000Z',
        y: 7.648408317404651,
      },
      {
        x: '2023-10-16T00:00:00.000Z',
        y: 7.647367482970262,
      },
      {
        x: '2023-10-17T00:00:00.000Z',
        y: 7.646326648535873,
      },
      {
        x: '2023-10-18T00:00:00.000Z',
        y: 7.645285814101484,
      },
      {
        x: '2023-10-19T00:00:00.000Z',
        y: 7.6442449796670955,
      },
      {
        x: '2023-10-20T00:00:00.000Z',
        y: 7.643204145232706,
      },
      {
        x: '2023-10-21T00:00:00.000Z',
        y: 7.646432401696661,
      },
      {
        x: '2023-10-22T00:00:00.000Z',
        y: 7.649660658160617,
      },
      {
        x: '2023-10-23T00:00:00.000Z',
        y: 7.652888914624572,
      },
      {
        x: '2023-10-24T00:00:00.000Z',
        y: 7.656117171088528,
      },
      {
        x: '2023-10-25T00:00:00.000Z',
        y: 7.659345427552484,
      },
      {
        x: '2023-10-26T00:00:00.000Z',
        y: 7.66257368401644,
      },
      {
        x: '2023-10-27T00:00:00.000Z',
        y: 7.665801940480396,
      },
      {
        x: '2023-10-28T00:00:00.000Z',
        y: 7.669030196944349,
      },
      {
        x: '2023-10-29T00:00:00.000Z',
        y: 7.6573571866784285,
      },
      {
        x: '2023-10-30T00:00:00.000Z',
        y: 7.645684176412508,
      },
      {
        x: '2023-10-31T00:00:00.000Z',
        y: 7.634011166146587,
      },
      {
        x: '2023-11-01T00:00:00.000Z',
        y: 7.622338155880667,
      },
      {
        x: '2023-11-02T00:00:00.000Z',
        y: 7.610665145614746,
      },
      {
        x: '2023-11-03T00:00:00.000Z',
        y: 7.5989921353488254,
      },
      {
        x: '2023-11-04T00:00:00.000Z',
        y: 7.587319125082905,
      },
      {
        x: '2023-11-05T00:00:00.000Z',
        y: 7.575646114816985,
      },
      {
        x: '2023-11-06T00:00:00.000Z',
        y: 7.576176964818424,
      },
      {
        x: '2023-11-07T00:00:00.000Z',
        y: 7.576707814819862,
      },
      {
        x: '2023-11-08T00:00:00.000Z',
        y: 7.577238664821301,
      },
      {
        x: '2023-11-09T00:00:00.000Z',
        y: 7.577769514822739,
      },
      {
        x: '2023-11-10T00:00:00.000Z',
        y: 7.578300364824178,
      },
      {
        x: '2023-11-11T00:00:00.000Z',
        y: 7.578831214825616,
      },
      {
        x: '2023-11-12T00:00:00.000Z',
        y: 7.5793620648270545,
      },
      {
        x: '2023-11-13T00:00:00.000Z',
        y: 7.57989291482849,
      },
      {
        x: '2023-11-14T00:00:00.000Z',
        y: 7.58176300140898,
      },
      {
        x: '2023-11-15T00:00:00.000Z',
        y: 7.58363308798947,
      },
      {
        x: '2023-11-16T00:00:00.000Z',
        y: 7.5855031745699595,
      },
      {
        x: '2023-11-17T00:00:00.000Z',
        y: 7.587373261150449,
      },
      {
        x: '2023-11-18T00:00:00.000Z',
        y: 7.589243347730939,
      },
      {
        x: '2023-11-19T00:00:00.000Z',
        y: 7.591113434311429,
      },
      {
        x: '2023-11-20T00:00:00.000Z',
        y: 7.592983520891918,
      },
      {
        x: '2023-11-21T00:00:00.000Z',
        y: 7.594853607472411,
      },
      {
        x: '2023-11-22T00:00:00.000Z',
        y: 7.589469164289711,
      },
      {
        x: '2023-11-23T00:00:00.000Z',
        y: 7.584084721107011,
      },
      {
        x: '2023-11-24T00:00:00.000Z',
        y: 7.578700277924312,
      },
      {
        x: '2023-11-25T00:00:00.000Z',
        y: 7.573315834741612,
      },
      {
        x: '2023-11-26T00:00:00.000Z',
        y: 7.567931391558912,
      },
      {
        x: '2023-11-27T00:00:00.000Z',
        y: 7.562546948376212,
      },
      {
        x: '2023-11-28T00:00:00.000Z',
        y: 7.557162505193513,
      },
      {
        x: '2023-11-29T00:00:00.000Z',
        y: 7.55177806201081,
      },
      {
        x: '2023-11-30T00:00:00.000Z',
        y: 7.554465910773166,
      },
      {
        x: '2023-12-01T00:00:00.000Z',
        y: 7.557153759535521,
      },
      {
        x: '2023-12-02T00:00:00.000Z',
        y: 7.5598416082978765,
      },
      {
        x: '2023-12-03T00:00:00.000Z',
        y: 7.562529457060232,
      },
      {
        x: '2023-12-04T00:00:00.000Z',
        y: 7.565217305822587,
      },
      {
        x: '2023-12-05T00:00:00.000Z',
        y: 7.567905154584943,
      },
      {
        x: '2023-12-06T00:00:00.000Z',
        y: 7.570593003347298,
      },
      {
        x: '2023-12-07T00:00:00.000Z',
        y: 7.573280852109653,
      },
      {
        x: '2023-12-08T00:00:00.000Z',
        y: 7.574528592376106,
      },
      {
        x: '2023-12-09T00:00:00.000Z',
        y: 7.57577633264256,
      },
      {
        x: '2023-12-10T00:00:00.000Z',
        y: 7.577024072909014,
      },
      {
        x: '2023-12-11T00:00:00.000Z',
        y: 7.578271813175467,
      },
      {
        x: '2023-12-12T00:00:00.000Z',
        y: 7.579519553441921,
      },
      {
        x: '2023-12-13T00:00:00.000Z',
        y: 7.580767293708375,
      },
      {
        x: '2023-12-14T00:00:00.000Z',
        y: 7.5820150339748285,
      },
      {
        x: '2023-12-15T00:00:00.000Z',
        y: 7.583262774241283,
      },
      {
        x: '2023-12-16T00:00:00.000Z',
        y: 7.5787046023795135,
      },
      {
        x: '2023-12-17T00:00:00.000Z',
        y: 7.574146430517744,
      },
      {
        x: '2023-12-18T00:00:00.000Z',
        y: 7.569588258655974,
      },
      {
        x: '2023-12-19T00:00:00.000Z',
        y: 7.565030086794205,
      },
      {
        x: '2023-12-20T00:00:00.000Z',
        y: 7.560471914932435,
      },
      {
        x: '2023-12-21T00:00:00.000Z',
        y: 7.555913743070666,
      },
      {
        x: '2023-12-22T00:00:00.000Z',
        y: 7.551355571208896,
      },
      {
        x: '2023-12-23T00:00:00.000Z',
        y: 7.546797399347126,
      },
      {
        x: '2023-12-24T00:00:00.000Z',
        y: 7.545408907341978,
      },
      {
        x: '2023-12-25T00:00:00.000Z',
        y: 7.5440204153368295,
      },
      {
        x: '2023-12-26T00:00:00.000Z',
        y: 7.542631923331681,
      },
      {
        x: '2023-12-27T00:00:00.000Z',
        y: 7.541243431326533,
      },
      {
        x: '2023-12-28T00:00:00.000Z',
        y: 7.539854939321385,
      },
      {
        x: '2023-12-29T00:00:00.000Z',
        y: 7.538466447316237,
      },
      {
        x: '2023-12-30T00:00:00.000Z',
        y: 7.537077955311089,
      },
      {
        x: '2023-12-31T00:00:00.000Z',
        y: 7.535689463305941,
      },
    ],
    styleKey: 'light',
    id: 'mid',
    title: 'CII Forecast',
  },
  {
    data: [
      {
        x: '2023-08-01T00:00:00.000Z',
        y: 7.951013637003423,
      },
      {
        x: '2023-08-02T00:00:00.000Z',
        y: 7.951311996134032,
      },
      {
        x: '2023-08-03T00:00:00.000Z',
        y: 7.95161035526464,
      },
      {
        x: '2023-08-04T00:00:00.000Z',
        y: 7.951908714395249,
      },
      {
        x: '2023-08-05T00:00:00.000Z',
        y: 7.952207073525858,
      },
      {
        x: '2023-08-06T00:00:00.000Z',
        y: 7.952505432656467,
      },
      {
        x: '2023-08-07T00:00:00.000Z',
        y: 7.952803791787075,
      },
      {
        x: '2023-08-08T00:00:00.000Z',
        y: 7.953102150917684,
      },
      {
        x: '2023-08-09T00:00:00.000Z',
        y: 7.953400510048293,
      },
      {
        x: '2023-08-10T00:00:00.000Z',
        y: 7.95296506802024,
      },
      {
        x: '2023-08-11T00:00:00.000Z',
        y: 7.952529625992187,
      },
      {
        x: '2023-08-12T00:00:00.000Z',
        y: 7.952094183964134,
      },
      {
        x: '2023-08-13T00:00:00.000Z',
        y: 7.951658741936082,
      },
      {
        x: '2023-08-14T00:00:00.000Z',
        y: 7.951223299908029,
      },
      {
        x: '2023-08-15T00:00:00.000Z',
        y: 7.950787857879976,
      },
      {
        x: '2023-08-16T00:00:00.000Z',
        y: 7.950352415851923,
      },
      {
        x: '2023-08-17T00:00:00.000Z',
        y: 7.949916973823871,
      },
      {
        x: '2023-08-18T00:00:00.000Z',
        y: 7.955170326788988,
      },
      {
        x: '2023-08-19T00:00:00.000Z',
        y: 7.960423679754104,
      },
      {
        x: '2023-08-20T00:00:00.000Z',
        y: 7.965677032719221,
      },
      {
        x: '2023-08-21T00:00:00.000Z',
        y: 7.970930385684337,
      },
      {
        x: '2023-08-22T00:00:00.000Z',
        y: 7.976183738649453,
      },
      {
        x: '2023-08-23T00:00:00.000Z',
        y: 7.98143709161457,
      },
      {
        x: '2023-08-24T00:00:00.000Z',
        y: 7.986690444579686,
      },
      {
        x: '2023-08-25T00:00:00.000Z',
        y: 7.9919437975448036,
      },
      {
        x: '2023-08-26T00:00:00.000Z',
        y: 7.994007221254782,
      },
      {
        x: '2023-08-27T00:00:00.000Z',
        y: 7.996070644964761,
      },
      {
        x: '2023-08-28T00:00:00.000Z',
        y: 7.99813406867474,
      },
      {
        x: '2023-08-29T00:00:00.000Z',
        y: 8.000197492384718,
      },
      {
        x: '2023-08-30T00:00:00.000Z',
        y: 8.002260916094697,
      },
      {
        x: '2023-08-31T00:00:00.000Z',
        y: 8.004324339804676,
      },
      {
        x: '2023-09-01T00:00:00.000Z',
        y: 8.006387763514654,
      },
      {
        x: '2023-09-02T00:00:00.000Z',
        y: 8.008451187224633,
      },
      {
        x: '2023-09-03T00:00:00.000Z',
        y: 8.003259835677046,
      },
      {
        x: '2023-09-04T00:00:00.000Z',
        y: 7.998068484129458,
      },
      {
        x: '2023-09-05T00:00:00.000Z',
        y: 7.992877132581871,
      },
      {
        x: '2023-09-06T00:00:00.000Z',
        y: 7.987685781034283,
      },
      {
        x: '2023-09-07T00:00:00.000Z',
        y: 7.982494429486696,
      },
      {
        x: '2023-09-08T00:00:00.000Z',
        y: 7.9773030779391085,
      },
      {
        x: '2023-09-09T00:00:00.000Z',
        y: 7.972111726391521,
      },
      {
        x: '2023-09-10T00:00:00.000Z',
        y: 7.966920374843933,
      },
      {
        x: '2023-09-11T00:00:00.000Z',
        y: 7.97100631086189,
      },
      {
        x: '2023-09-12T00:00:00.000Z',
        y: 7.975092246879847,
      },
      {
        x: '2023-09-13T00:00:00.000Z',
        y: 7.979178182897805,
      },
      {
        x: '2023-09-14T00:00:00.000Z',
        y: 7.983264118915762,
      },
      {
        x: '2023-09-15T00:00:00.000Z',
        y: 7.987350054933719,
      },
      {
        x: '2023-09-16T00:00:00.000Z',
        y: 7.991435990951676,
      },
      {
        x: '2023-09-17T00:00:00.000Z',
        y: 7.995521926969634,
      },
      {
        x: '2023-09-18T00:00:00.000Z',
        y: 7.999607862987592,
      },
      {
        x: '2023-09-19T00:00:00.000Z',
        y: 7.998848871150297,
      },
      {
        x: '2023-09-20T00:00:00.000Z',
        y: 7.998089879313003,
      },
      {
        x: '2023-09-21T00:00:00.000Z',
        y: 7.997330887475709,
      },
      {
        x: '2023-09-22T00:00:00.000Z',
        y: 7.996571895638414,
      },
      {
        x: '2023-09-23T00:00:00.000Z',
        y: 7.99581290380112,
      },
      {
        x: '2023-09-24T00:00:00.000Z',
        y: 7.995053911963826,
      },
      {
        x: '2023-09-25T00:00:00.000Z',
        y: 7.994294920126531,
      },
      {
        x: '2023-09-26T00:00:00.000Z',
        y: 7.993535928289239,
      },
      {
        x: '2023-09-27T00:00:00.000Z',
        y: 8.001160954776907,
      },
      {
        x: '2023-09-28T00:00:00.000Z',
        y: 8.008785981264575,
      },
      {
        x: '2023-09-29T00:00:00.000Z',
        y: 8.016411007752243,
      },
      {
        x: '2023-09-30T00:00:00.000Z',
        y: 8.024036034239911,
      },
      {
        x: '2023-10-01T00:00:00.000Z',
        y: 8.03166106072758,
      },
      {
        x: '2023-10-02T00:00:00.000Z',
        y: 8.039286087215247,
      },
      {
        x: '2023-10-03T00:00:00.000Z',
        y: 8.046911113702915,
      },
      {
        x: '2023-10-04T00:00:00.000Z',
        y: 8.054536140190583,
      },
      {
        x: '2023-10-05T00:00:00.000Z',
        y: 8.050301594403802,
      },
      {
        x: '2023-10-06T00:00:00.000Z',
        y: 8.04606704861702,
      },
      {
        x: '2023-10-07T00:00:00.000Z',
        y: 8.041832502830239,
      },
      {
        x: '2023-10-08T00:00:00.000Z',
        y: 8.037597957043458,
      },
      {
        x: '2023-10-09T00:00:00.000Z',
        y: 8.033363411256676,
      },
      {
        x: '2023-10-10T00:00:00.000Z',
        y: 8.029128865469895,
      },
      {
        x: '2023-10-11T00:00:00.000Z',
        y: 8.024894319683114,
      },
      {
        x: '2023-10-12T00:00:00.000Z',
        y: 8.02065977389633,
      },
      {
        x: '2023-10-13T00:00:00.000Z',
        y: 8.026071216984587,
      },
      {
        x: '2023-10-14T00:00:00.000Z',
        y: 8.031482660072843,
      },
      {
        x: '2023-10-15T00:00:00.000Z',
        y: 8.0368941031611,
      },
      {
        x: '2023-10-16T00:00:00.000Z',
        y: 8.042305546249356,
      },
      {
        x: '2023-10-17T00:00:00.000Z',
        y: 8.047716989337612,
      },
      {
        x: '2023-10-18T00:00:00.000Z',
        y: 8.053128432425869,
      },
      {
        x: '2023-10-19T00:00:00.000Z',
        y: 8.058539875514125,
      },
      {
        x: '2023-10-20T00:00:00.000Z',
        y: 8.063951318602376,
      },
      {
        x: '2023-10-21T00:00:00.000Z',
        y: 8.064655182911904,
      },
      {
        x: '2023-10-22T00:00:00.000Z',
        y: 8.065359047221433,
      },
      {
        x: '2023-10-23T00:00:00.000Z',
        y: 8.066062911530961,
      },
      {
        x: '2023-10-24T00:00:00.000Z',
        y: 8.06676677584049,
      },
      {
        x: '2023-10-25T00:00:00.000Z',
        y: 8.067470640150018,
      },
      {
        x: '2023-10-26T00:00:00.000Z',
        y: 8.068174504459547,
      },
      {
        x: '2023-10-27T00:00:00.000Z',
        y: 8.068878368769075,
      },
      {
        x: '2023-10-28T00:00:00.000Z',
        y: 8.069582233078604,
      },
      {
        x: '2023-10-29T00:00:00.000Z',
        y: 8.070080421056396,
      },
      {
        x: '2023-10-30T00:00:00.000Z',
        y: 8.070578609034188,
      },
      {
        x: '2023-10-31T00:00:00.000Z',
        y: 8.07107679701198,
      },
      {
        x: '2023-11-01T00:00:00.000Z',
        y: 8.071574984989772,
      },
      {
        x: '2023-11-02T00:00:00.000Z',
        y: 8.072073172967563,
      },
      {
        x: '2023-11-03T00:00:00.000Z',
        y: 8.072571360945355,
      },
      {
        x: '2023-11-04T00:00:00.000Z',
        y: 8.073069548923147,
      },
      {
        x: '2023-11-05T00:00:00.000Z',
        y: 8.07356773690094,
      },
      {
        x: '2023-11-06T00:00:00.000Z',
        y: 8.07422968680525,
      },
      {
        x: '2023-11-07T00:00:00.000Z',
        y: 8.074891636709559,
      },
      {
        x: '2023-11-08T00:00:00.000Z',
        y: 8.075553586613868,
      },
      {
        x: '2023-11-09T00:00:00.000Z',
        y: 8.076215536518177,
      },
      {
        x: '2023-11-10T00:00:00.000Z',
        y: 8.076877486422486,
      },
      {
        x: '2023-11-11T00:00:00.000Z',
        y: 8.077539436326795,
      },
      {
        x: '2023-11-12T00:00:00.000Z',
        y: 8.078201386231104,
      },
      {
        x: '2023-11-13T00:00:00.000Z',
        y: 8.07886333613541,
      },
      {
        x: '2023-11-14T00:00:00.000Z',
        y: 8.076422399616584,
      },
      {
        x: '2023-11-15T00:00:00.000Z',
        y: 8.073981463097759,
      },
      {
        x: '2023-11-16T00:00:00.000Z',
        y: 8.071540526578934,
      },
      {
        x: '2023-11-17T00:00:00.000Z',
        y: 8.069099590060109,
      },
      {
        x: '2023-11-18T00:00:00.000Z',
        y: 8.066658653541284,
      },
      {
        x: '2023-11-19T00:00:00.000Z',
        y: 8.064217717022458,
      },
      {
        x: '2023-11-20T00:00:00.000Z',
        y: 8.061776780503633,
      },
      {
        x: '2023-11-21T00:00:00.000Z',
        y: 8.059335843984806,
      },
      {
        x: '2023-11-22T00:00:00.000Z',
        y: 8.058783006733824,
      },
      {
        x: '2023-11-23T00:00:00.000Z',
        y: 8.058230169482842,
      },
      {
        x: '2023-11-24T00:00:00.000Z',
        y: 8.05767733223186,
      },
      {
        x: '2023-11-25T00:00:00.000Z',
        y: 8.057124494980878,
      },
      {
        x: '2023-11-26T00:00:00.000Z',
        y: 8.056571657729895,
      },
      {
        x: '2023-11-27T00:00:00.000Z',
        y: 8.056018820478913,
      },
      {
        x: '2023-11-28T00:00:00.000Z',
        y: 8.055465983227931,
      },
      {
        x: '2023-11-29T00:00:00.000Z',
        y: 8.05491314597695,
      },
      {
        x: '2023-11-30T00:00:00.000Z',
        y: 8.053321041836684,
      },
      {
        x: '2023-12-01T00:00:00.000Z',
        y: 8.051728937696417,
      },
      {
        x: '2023-12-02T00:00:00.000Z',
        y: 8.05013683355615,
      },
      {
        x: '2023-12-03T00:00:00.000Z',
        y: 8.048544729415884,
      },
      {
        x: '2023-12-04T00:00:00.000Z',
        y: 8.046952625275617,
      },
      {
        x: '2023-12-05T00:00:00.000Z',
        y: 8.04536052113535,
      },
      {
        x: '2023-12-06T00:00:00.000Z',
        y: 8.043768416995084,
      },
      {
        x: '2023-12-07T00:00:00.000Z',
        y: 8.042176312854815,
      },
      {
        x: '2023-12-08T00:00:00.000Z',
        y: 8.04744553698352,
      },
      {
        x: '2023-12-09T00:00:00.000Z',
        y: 8.052714761112226,
      },
      {
        x: '2023-12-10T00:00:00.000Z',
        y: 8.05798398524093,
      },
      {
        x: '2023-12-11T00:00:00.000Z',
        y: 8.063253209369636,
      },
      {
        x: '2023-12-12T00:00:00.000Z',
        y: 8.068522433498341,
      },
      {
        x: '2023-12-13T00:00:00.000Z',
        y: 8.073791657627046,
      },
      {
        x: '2023-12-14T00:00:00.000Z',
        y: 8.079060881755751,
      },
      {
        x: '2023-12-15T00:00:00.000Z',
        y: 8.084330105884451,
      },
      {
        x: '2023-12-16T00:00:00.000Z',
        y: 8.084817503656726,
      },
      {
        x: '2023-12-17T00:00:00.000Z',
        y: 8.085304901429001,
      },
      {
        x: '2023-12-18T00:00:00.000Z',
        y: 8.085792299201277,
      },
      {
        x: '2023-12-19T00:00:00.000Z',
        y: 8.086279696973552,
      },
      {
        x: '2023-12-20T00:00:00.000Z',
        y: 8.086767094745827,
      },
      {
        x: '2023-12-21T00:00:00.000Z',
        y: 8.087254492518102,
      },
      {
        x: '2023-12-22T00:00:00.000Z',
        y: 8.087741890290378,
      },
      {
        x: '2023-12-23T00:00:00.000Z',
        y: 8.088229288062657,
      },
      {
        x: '2023-12-24T00:00:00.000Z',
        y: 8.089552625006837,
      },
      {
        x: '2023-12-25T00:00:00.000Z',
        y: 8.090875961951017,
      },
      {
        x: '2023-12-26T00:00:00.000Z',
        y: 8.092199298895197,
      },
      {
        x: '2023-12-27T00:00:00.000Z',
        y: 8.093522635839378,
      },
      {
        x: '2023-12-28T00:00:00.000Z',
        y: 8.094845972783558,
      },
      {
        x: '2023-12-29T00:00:00.000Z',
        y: 8.096169309727738,
      },
      {
        x: '2023-12-30T00:00:00.000Z',
        y: 8.097492646671919,
      },
      {
        x: '2023-12-31T00:00:00.000Z',
        y: 8.098815983616097,
      },
    ],
    styleKey: 'light',
    id: 'up',
  },
  {
    data: [
      {
        x: '2023-08-01T00:00:00.000Z',
        y: 7.953332770544747,
      },
      {
        x: '2023-08-02T00:00:00.000Z',
        y: 7.941492841507733,
      },
      {
        x: '2023-08-03T00:00:00.000Z',
        y: 7.92965291247072,
      },
      {
        x: '2023-08-04T00:00:00.000Z',
        y: 7.917812983433707,
      },
      {
        x: '2023-08-05T00:00:00.000Z',
        y: 7.905973054396695,
      },
      {
        x: '2023-08-06T00:00:00.000Z',
        y: 7.894133125359682,
      },
      {
        x: '2023-08-07T00:00:00.000Z',
        y: 7.882293196322669,
      },
      {
        x: '2023-08-08T00:00:00.000Z',
        y: 7.870453267285656,
      },
      {
        x: '2023-08-09T00:00:00.000Z',
        y: 7.858613338248641,
      },
      {
        x: '2023-08-10T00:00:00.000Z',
        y: 7.851518956958863,
      },
      {
        x: '2023-08-11T00:00:00.000Z',
        y: 7.844424575669086,
      },
      {
        x: '2023-08-12T00:00:00.000Z',
        y: 7.837330194379309,
      },
      {
        x: '2023-08-13T00:00:00.000Z',
        y: 7.830235813089532,
      },
      {
        x: '2023-08-14T00:00:00.000Z',
        y: 7.823141431799755,
      },
      {
        x: '2023-08-15T00:00:00.000Z',
        y: 7.816047050509978,
      },
      {
        x: '2023-08-16T00:00:00.000Z',
        y: 7.808952669220201,
      },
      {
        x: '2023-08-17T00:00:00.000Z',
        y: 7.801858287930421,
      },
      {
        x: '2023-08-18T00:00:00.000Z',
        y: 7.789329761026633,
      },
      {
        x: '2023-08-19T00:00:00.000Z',
        y: 7.776801234122845,
      },
      {
        x: '2023-08-20T00:00:00.000Z',
        y: 7.764272707219058,
      },
      {
        x: '2023-08-21T00:00:00.000Z',
        y: 7.75174418031527,
      },
      {
        x: '2023-08-22T00:00:00.000Z',
        y: 7.739215653411482,
      },
      {
        x: '2023-08-23T00:00:00.000Z',
        y: 7.726687126507694,
      },
      {
        x: '2023-08-24T00:00:00.000Z',
        y: 7.714158599603906,
      },
      {
        x: '2023-08-25T00:00:00.000Z',
        y: 7.701630072700118,
      },
      {
        x: '2023-08-26T00:00:00.000Z',
        y: 7.690183489971851,
      },
      {
        x: '2023-08-27T00:00:00.000Z',
        y: 7.678736907243584,
      },
      {
        x: '2023-08-28T00:00:00.000Z',
        y: 7.667290324515317,
      },
      {
        x: '2023-08-29T00:00:00.000Z',
        y: 7.65584374178705,
      },
      {
        x: '2023-08-30T00:00:00.000Z',
        y: 7.644397159058784,
      },
      {
        x: '2023-08-31T00:00:00.000Z',
        y: 7.632950576330517,
      },
      {
        x: '2023-09-01T00:00:00.000Z',
        y: 7.62150399360225,
      },
      {
        x: '2023-09-02T00:00:00.000Z',
        y: 7.61005741087398,
      },
      {
        x: '2023-09-03T00:00:00.000Z',
        y: 7.597249596114337,
      },
      {
        x: '2023-09-04T00:00:00.000Z',
        y: 7.584441781354695,
      },
      {
        x: '2023-09-05T00:00:00.000Z',
        y: 7.571633966595052,
      },
      {
        x: '2023-09-06T00:00:00.000Z',
        y: 7.55882615183541,
      },
      {
        x: '2023-09-07T00:00:00.000Z',
        y: 7.546018337075767,
      },
      {
        x: '2023-09-08T00:00:00.000Z',
        y: 7.533210522316125,
      },
      {
        x: '2023-09-09T00:00:00.000Z',
        y: 7.5204027075564825,
      },
      {
        x: '2023-09-10T00:00:00.000Z',
        y: 7.5075948927968374,
      },
      {
        x: '2023-09-11T00:00:00.000Z',
        y: 7.500700378054059,
      },
      {
        x: '2023-09-12T00:00:00.000Z',
        y: 7.493805863311282,
      },
      {
        x: '2023-09-13T00:00:00.000Z',
        y: 7.486911348568505,
      },
      {
        x: '2023-09-14T00:00:00.000Z',
        y: 7.480016833825728,
      },
      {
        x: '2023-09-15T00:00:00.000Z',
        y: 7.47312231908295,
      },
      {
        x: '2023-09-16T00:00:00.000Z',
        y: 7.466227804340173,
      },
      {
        x: '2023-09-17T00:00:00.000Z',
        y: 7.459333289597396,
      },
      {
        x: '2023-09-18T00:00:00.000Z',
        y: 7.452438774854616,
      },
      {
        x: '2023-09-19T00:00:00.000Z',
        y: 7.450624053208125,
      },
      {
        x: '2023-09-20T00:00:00.000Z',
        y: 7.448809331561634,
      },
      {
        x: '2023-09-21T00:00:00.000Z',
        y: 7.4469946099151425,
      },
      {
        x: '2023-09-22T00:00:00.000Z',
        y: 7.445179888268651,
      },
      {
        x: '2023-09-23T00:00:00.000Z',
        y: 7.44336516662216,
      },
      {
        x: '2023-09-24T00:00:00.000Z',
        y: 7.441550444975668,
      },
      {
        x: '2023-09-25T00:00:00.000Z',
        y: 7.439735723329177,
      },
      {
        x: '2023-09-26T00:00:00.000Z',
        y: 7.437921001682688,
      },
      {
        x: '2023-09-27T00:00:00.000Z',
        y: 7.43016845854847,
      },
      {
        x: '2023-09-28T00:00:00.000Z',
        y: 7.422415915414253,
      },
      {
        x: '2023-09-29T00:00:00.000Z',
        y: 7.414663372280035,
      },
      {
        x: '2023-09-30T00:00:00.000Z',
        y: 7.406910829145818,
      },
      {
        x: '2023-10-01T00:00:00.000Z',
        y: 7.3991582860116,
      },
      {
        x: '2023-10-02T00:00:00.000Z',
        y: 7.3914057428773825,
      },
      {
        x: '2023-10-03T00:00:00.000Z',
        y: 7.383653199743165,
      },
      {
        x: '2023-10-04T00:00:00.000Z',
        y: 7.375900656608946,
      },
      {
        x: '2023-10-05T00:00:00.000Z',
        y: 7.368385237308678,
      },
      {
        x: '2023-10-06T00:00:00.000Z',
        y: 7.36086981800841,
      },
      {
        x: '2023-10-07T00:00:00.000Z',
        y: 7.353354398708142,
      },
      {
        x: '2023-10-08T00:00:00.000Z',
        y: 7.345838979407874,
      },
      {
        x: '2023-10-09T00:00:00.000Z',
        y: 7.338323560107606,
      },
      {
        x: '2023-10-10T00:00:00.000Z',
        y: 7.330808140807338,
      },
      {
        x: '2023-10-11T00:00:00.000Z',
        y: 7.32329272150707,
      },
      {
        x: '2023-10-12T00:00:00.000Z',
        y: 7.3157773022068,
      },
      {
        x: '2023-10-13T00:00:00.000Z',
        y: 7.308496917579793,
      },
      {
        x: '2023-10-14T00:00:00.000Z',
        y: 7.301216532952788,
      },
      {
        x: '2023-10-15T00:00:00.000Z',
        y: 7.293936148325782,
      },
      {
        x: '2023-10-16T00:00:00.000Z',
        y: 7.286655763698777,
      },
      {
        x: '2023-10-17T00:00:00.000Z',
        y: 7.279375379071771,
      },
      {
        x: '2023-10-18T00:00:00.000Z',
        y: 7.272094994444766,
      },
      {
        x: '2023-10-19T00:00:00.000Z',
        y: 7.26481460981776,
      },
      {
        x: '2023-10-20T00:00:00.000Z',
        y: 7.257534225190752,
      },
      {
        x: '2023-10-21T00:00:00.000Z',
        y: 7.2510667609915,
      },
      {
        x: '2023-10-22T00:00:00.000Z',
        y: 7.244599296792248,
      },
      {
        x: '2023-10-23T00:00:00.000Z',
        y: 7.2381318325929955,
      },
      {
        x: '2023-10-24T00:00:00.000Z',
        y: 7.231664368393743,
      },
      {
        x: '2023-10-25T00:00:00.000Z',
        y: 7.225196904194491,
      },
      {
        x: '2023-10-26T00:00:00.000Z',
        y: 7.218729439995239,
      },
      {
        x: '2023-10-27T00:00:00.000Z',
        y: 7.212261975795987,
      },
      {
        x: '2023-10-28T00:00:00.000Z',
        y: 7.205794511596732,
      },
      {
        x: '2023-10-29T00:00:00.000Z',
        y: 7.197822542245407,
      },
      {
        x: '2023-10-30T00:00:00.000Z',
        y: 7.189850572894082,
      },
      {
        x: '2023-10-31T00:00:00.000Z',
        y: 7.181878603542757,
      },
      {
        x: '2023-11-01T00:00:00.000Z',
        y: 7.173906634191432,
      },
      {
        x: '2023-11-02T00:00:00.000Z',
        y: 7.165934664840107,
      },
      {
        x: '2023-11-03T00:00:00.000Z',
        y: 7.1579626954887825,
      },
      {
        x: '2023-11-04T00:00:00.000Z',
        y: 7.149990726137458,
      },
      {
        x: '2023-11-05T00:00:00.000Z',
        y: 7.142018756786132,
      },
      {
        x: '2023-11-06T00:00:00.000Z',
        y: 7.13774573055466,
      },
      {
        x: '2023-11-07T00:00:00.000Z',
        y: 7.1334727043231885,
      },
      {
        x: '2023-11-08T00:00:00.000Z',
        y: 7.129199678091717,
      },
      {
        x: '2023-11-09T00:00:00.000Z',
        y: 7.124926651860245,
      },
      {
        x: '2023-11-10T00:00:00.000Z',
        y: 7.120653625628774,
      },
      {
        x: '2023-11-11T00:00:00.000Z',
        y: 7.116380599397302,
      },
      {
        x: '2023-11-12T00:00:00.000Z',
        y: 7.11210757316583,
      },
      {
        x: '2023-11-13T00:00:00.000Z',
        y: 7.107834546934356,
      },
      {
        x: '2023-11-14T00:00:00.000Z',
        y: 7.113263821832722,
      },
      {
        x: '2023-11-15T00:00:00.000Z',
        y: 7.1186930967310875,
      },
      {
        x: '2023-11-16T00:00:00.000Z',
        y: 7.124122371629453,
      },
      {
        x: '2023-11-17T00:00:00.000Z',
        y: 7.129551646527819,
      },
      {
        x: '2023-11-18T00:00:00.000Z',
        y: 7.134980921426185,
      },
      {
        x: '2023-11-19T00:00:00.000Z',
        y: 7.1404101963245505,
      },
      {
        x: '2023-11-20T00:00:00.000Z',
        y: 7.145839471222916,
      },
      {
        x: '2023-11-21T00:00:00.000Z',
        y: 7.151268746121282,
      },
      {
        x: '2023-11-22T00:00:00.000Z',
        y: 7.148992201079138,
      },
      {
        x: '2023-11-23T00:00:00.000Z',
        y: 7.146715656036994,
      },
      {
        x: '2023-11-24T00:00:00.000Z',
        y: 7.14443911099485,
      },
      {
        x: '2023-11-25T00:00:00.000Z',
        y: 7.142162565952706,
      },
      {
        x: '2023-11-26T00:00:00.000Z',
        y: 7.139886020910562,
      },
      {
        x: '2023-11-27T00:00:00.000Z',
        y: 7.137609475868418,
      },
      {
        x: '2023-11-28T00:00:00.000Z',
        y: 7.135332930826274,
      },
      {
        x: '2023-11-29T00:00:00.000Z',
        y: 7.133056385784127,
      },
      {
        x: '2023-11-30T00:00:00.000Z',
        y: 7.11963366422626,
      },
      {
        x: '2023-12-01T00:00:00.000Z',
        y: 7.106210942668394,
      },
      {
        x: '2023-12-02T00:00:00.000Z',
        y: 7.092788221110528,
      },
      {
        x: '2023-12-03T00:00:00.000Z',
        y: 7.079365499552662,
      },
      {
        x: '2023-12-04T00:00:00.000Z',
        y: 7.065942777994795,
      },
      {
        x: '2023-12-05T00:00:00.000Z',
        y: 7.052520056436929,
      },
      {
        x: '2023-12-06T00:00:00.000Z',
        y: 7.039097334879063,
      },
      {
        x: '2023-12-07T00:00:00.000Z',
        y: 7.025674613321194,
      },
      {
        x: '2023-12-08T00:00:00.000Z',
        y: 7.029803102919473,
      },
      {
        x: '2023-12-09T00:00:00.000Z',
        y: 7.033931592517751,
      },
      {
        x: '2023-12-10T00:00:00.000Z',
        y: 7.038060082116029,
      },
      {
        x: '2023-12-11T00:00:00.000Z',
        y: 7.042188571714307,
      },
      {
        x: '2023-12-12T00:00:00.000Z',
        y: 7.046317061312585,
      },
      {
        x: '2023-12-13T00:00:00.000Z',
        y: 7.0504455509108634,
      },
      {
        x: '2023-12-14T00:00:00.000Z',
        y: 7.0545740405091415,
      },
      {
        x: '2023-12-15T00:00:00.000Z',
        y: 7.058702530107422,
      },
      {
        x: '2023-12-16T00:00:00.000Z',
        y: 7.0575330069948095,
      },
      {
        x: '2023-12-17T00:00:00.000Z',
        y: 7.056363483882197,
      },
      {
        x: '2023-12-18T00:00:00.000Z',
        y: 7.055193960769584,
      },
      {
        x: '2023-12-19T00:00:00.000Z',
        y: 7.054024437656971,
      },
      {
        x: '2023-12-20T00:00:00.000Z',
        y: 7.052854914544358,
      },
      {
        x: '2023-12-21T00:00:00.000Z',
        y: 7.051685391431746,
      },
      {
        x: '2023-12-22T00:00:00.000Z',
        y: 7.050515868319133,
      },
      {
        x: '2023-12-23T00:00:00.000Z',
        y: 7.0493463452065175,
      },
      {
        x: '2023-12-24T00:00:00.000Z',
        y: 7.0469670795120525,
      },
      {
        x: '2023-12-25T00:00:00.000Z',
        y: 7.0445878138175875,
      },
      {
        x: '2023-12-26T00:00:00.000Z',
        y: 7.0422085481231225,
      },
      {
        x: '2023-12-27T00:00:00.000Z',
        y: 7.0398292824286575,
      },
      {
        x: '2023-12-28T00:00:00.000Z',
        y: 7.0374500167341925,
      },
      {
        x: '2023-12-29T00:00:00.000Z',
        y: 7.0350707510397275,
      },
      {
        x: '2023-12-30T00:00:00.000Z',
        y: 7.0326914853452624,
      },
      {
        x: '2023-12-31T00:00:00.000Z',
        y: 7.0303122196507974,
      },
    ],
    styleKey: 'light',
    id: 'low',
  },
];

export const victoryPointScatters: VictoryPointScatters = [
  {
    data: [{ y: 7.943747962538374, x: '2023-07-31 10:00:00' }],
    styleKey: 'A',
    id: 'A',
    title: 'CII',
  },
];

export const mockRatingRanges: RatingRanges = {
  A: [2.7216715335273474, 9.072238445091157],
  B: [9.072238445091157, 10.289246041383874],
  C: [10.289246041383874, 11.948801854510307],
  D: [11.948801854510307, 14.161542938678881],
  E: [14.161542938678881, 21.242314408018323],
};
